import useSWR from 'swr';
import { Album } from '@/models/album';
import { EmpeDriveService } from '@/services/empe-drive';

export const useAlbum = (albumId: Album['id']) => {
    return useSWR(albumId ? `/albums/${albumId}` : null, () => EmpeDriveService.getAlbum(albumId));
};
